import { useCallback, useEffect, useState } from "react";
import ProductsAPI from "../services/ProductsAPI";
import { appConfig } from "../app.config";

export default function Dashboard() {
  const [dashBoardLink, setDashBoardLink] = useState(null);

  useEffect(() => {
    ProductsAPI.getCustomerDashBoard().then((response) =>
      setDashBoardLink(response.dashboard)
    );
    appConfig()
  }, []);

  const handleCloseDash = useCallback(() => {
    window.location.assign("/");
  }, []);

  return (
    <div style={{ width: "100vw", height: "100vh" }}>
      <button
        style={{
          position: "fixed",
          display: "block",
          top: 0,
          right: 0,
          fontSize: "1.5rem",
          width: "2rem",
          height: "2rem",
          borderRadius: "50%",
          border: "solid 0.2rem #b83e00",
          lineHeight: "0rem",
          cursor: "pointer",
          zIndex: 1002,
        }}
        onClick={handleCloseDash}
      >
        &times;
      </button>
      <iframe
        src={dashBoardLink}
        title="dashboard"
        loading="lazy"
        style={{
          display: dashBoardLink ? "block" : "none",
          width: "100%",
          height: "100%",
          position: "fixed",
          left: 0,
          top: 0,
          zIndex: 1001,
        }}
      ></iframe>
    </div>
  );
}
